import { render, staticRenderFns } from "./FilialeHeader.vue?vue&type=template&id=c8b848bc"
import script from "./FilialeHeader.vue?vue&type=script&lang=ts"
export * from "./FilialeHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports